$(function(){
  $(document).on("change", ".rb-industry-select",function(){
    var industry_child_id = $(this).data('industry-child') + Date.now()
    var child = $(this).parents('.rb-industry-select-parent').next().find('.rb-industry-select-child')
    child.attr('id', industry_child_id)
    $.ajax({
      url: '/registrations/industry_selects',
      type: 'GET',
      dataType: 'script',
      data: {
        parent_id: $(this).val(),
        name: $(this).data('name'),
        industry_child: industry_child_id
      }
    })
  })

})